import { useParams } from "react-router-dom";
import DesktopActiveMeetsComp from "@/components/desktop/desktop-active-meets-comp";

const DesktopActiveMeetingsPage = () => {
  const { short_code } = useParams();

  return <DesktopActiveMeetsComp _short_code={short_code} />;
};

export default DesktopActiveMeetingsPage;